import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const GridWrapper = props =>
  <div {...props}>
    {props.children}
  </div>;
GridWrapper.propTypes = {
  children: PropTypes.object,
};

export default styled(GridWrapper)`
--ag-range-selection-highlight-color: rgb(33, 150, 243, 0.3);

${p => p.isPlanningBoard || 'margin-left: -35px'};
${p => p.isPlanningBoard || 'margin-top: -4px'};
height: ${p => p.height};
display: flex;
flex-direction: column;
.ag-cell-focus {
  border-color: transparent !important;
}


.ag-root-wrapper {
  border: none;
}

.ag-header-select-all {
  margin-left: 0px;
}

.ag-header-select-all-details {
  margin-left: 15px !important;
}

.ag-details-row {
  padding: 0 !important;
}

.ag-row {
  border: none;
  background-color: white;
  &:hover:not(.ag-row-selected) {
    background-color: rgba(33, 150, 243, 0.1);
  }
}

.ag-details-grid .ag-header {
  border: none;
}

.ag-details-grid {
  margin-left: 55px;
  .ag-header-row {
    font-weight: 300 !important;
  }
  .ag-details-row {
    &:hover:not(.ag-row-selected) {
      background-color: rgba(33, 150, 243, 0.1);
    }
  }
}

.ag-row > .ag-cell > .ag-cell-wrapper > .ag-drag-handle.ag-row-drag.ag-hidden {
  display: flex !important;
  visibility: hidden !important;
}

.ag-selection-checkbox.ag-invisible::after {
  visibility: visible;
  font: var(--fa-font-solid);
  content: '\f05e';
  color: ${p => p.theme.colors.theme};
  margin-left: -14px;
}

${p => p.suppressMasterRowDrag && !p.suppressDetailsRowDrag && `
  .ag-row > .ag-cell > div > .row-drag {
    visibility: hidden !important;
  }
  .ag-details-row > .ag-cell > div > .row-drag {
    visibility: hidden !important;
  }
  // This code is to prevent multi DND for planningItems
  // Remove this and change the visibility: hidden in the .ag-dtails-row above to visible
  // once multi DND for planningitems is available
  .ag-details-row.ag-row-selected > .ag-cell > div > .row-drag {
    visibility: visible !important;
  }
`}
${p => !p.suppressMasterRowDrag && p.suppressDetailsRowDrag && `
  .ag-row > .ag-cell > div > .row-drag {
    visibility: visible !important;
  }
  .ag-details-row > .ag-cell > div > .row-drag {
    visibility: hidden !important;
  }
`}

.ag-checkbox, .ag-details-checkbox {
  left: ${p => p.isPlanningBoard ? 15 : 0}px !important;
  .ag-selection-checkbox {
    margin-right: 0px;
  }
}

.ag-cell[col-id="drag"] {
  padding: 0 !important;
  text-align: center;
  z-index: 2;
}

.ag-header-cell[col-id="children"] {
  padding: 0px !important;
  margin-left: ${p => p.isTickets ? 0 : -10}px !important;
}

.ag-cell[col-id="children"] {
  padding-left: 0px !important;
  margin-left: ${p => p.isTickets ? 0 : -10}px !important;
}

.ag-header-cell[col-id="drag"],.ag-header-cell[col-id="checkbox"] {
  padding: 0px !important;
  width: 40px !important;
  left: 10px !important;
}

.ag-row-level-1 {
  &:hover {
    background-color: transparent !important;
  }
}

${p => p.suppressMasterRowDrag && p.suppressDetailsRowDrag && `
  .ag-row > .ag-cell > div > .row-drag {
    visibility: hidden;
  }
  .ag-details-row > .ag-cell > div > .row-drag {
    visibility: hidden !important;
  }
`}

  .ag-row {
    pointer-events: auto !important;
  }
  .ag-details-checkbox > .ag-cell-wrapper > .ag-selection-checkbox > .ag-checkbox {
    pointer-events: ${p => p.disableDetailSelection ? 'none' : 'auto'} !important;
    > .ag-checkbox-input-wrapper {
      background: ${p => p.disableDetailSelection ? '#999' : '#fff'};
    }
  }

  .ag-row.highlighted {
    border: 1px solid ${p => p.theme.colors.theme};
    background: rgba(188, 223, 251, 0.3);
  }

  .ag-details-row {
    pointer-events: auto !important;
  }
  .ag-checkbox > .ag-cell-wrapper > .ag-selection-checkbox > .ag-checkbox {
    pointer-events: ${p => p.disableMasterSelection ? 'none' : 'auto'} !important;
    > .ag-checkbox-input-wrapper {
      background: ${p => p.disableMasterSelection ? '#999' : '#fff'};
    }
  }
  .ag-row-hover:not(.ag-row-selected):not(.ag-row-level-1) {
    .actions {
      visibility: visible !important;
      background-color: transparent;
      &:hover {
        background-color: #FFFFFF;
      }
    }
  }
  .ag-row-selected .actions {
    visibility: visible !important;
    background-color: #FFFFFF !important;
    &:hover {
      background-color: transparent !important;
    }
  }
`;
